import { createContext } from 'react';
import { getFeatureFlags } from '~/App/config/featureFlags';

export const FeatureToggleContext = createContext<Record<string, boolean>>(
  getFeatureFlags()
);
